<template>
  <div id="app" @keyup="shortcut">
    <v-app-bar
      app
      color="primary"
    >
      <div class="d-flex align-center">
        <v-img
          alt="SANS"
          class="shrink mr-2"
          contain
          :src="require('./assets/logo.png')"
          transition="scale-transition"
          width="60"
        />
      </div>
    </v-app-bar>
    <div v-if="!displayVideo">
      <countdown
        :message="videoData.title"
        :start-time="videoData.startTime"
        @launch="displayVideo = true"
      />
    </div>
    <div v-else oncontextmenu="return false">
      <video-panel ref="videoChild"
                   v-bind:video-url="videoData.videoUrl"
                   v-bind:video-type="videoData.mediaType"
                   v-bind:video-title="videoData.title"
                   v-bind:expiration-time="newDate"
                   v-bind:available-from="newDate"
                   return-url="http://localhost:9000"
                   style=""
                   @completed="goHome"
                   @reportState="incrementState"
                   @reportSkip="recordSkip"
      />
      <div class="hidden-md-and-down">
          <h3 style="margin-top:8px;">Keyboard Shortcuts</h3>
          <p>
            <span class="keyboardControlTitle">Stop / Start:</span><span class="keyboardControlValue">Space</span><br/>
            <span class="keyboardControlTitle">Toggle Fullscreen:</span><span class="keyboardControlValue">E</span><br/>
            <span class="keyboardControlTitle">Skip:</span><span class="keyboardControlValue">Forwards / Backwards Arrows</span>
          </p>
      </div>
    </div>
  </div>
</template>

<script>

import VideoPanel from './components/VideoPanel'
import Countdown from './components/Countdown'
import Bowser from 'bowser'
import 'videojs-youtube/dist/Youtube.js'

export default {
  name: 'App',
  components: {
    VideoPanel,
    Countdown
  },

  methods: {
    shortcut: function (event) {
      switch (event.keyCode) {
        case 32:
          this.$refs.videoChild.playpause()
          break
        case 39:
          this.$refs.videoChild.skip(5)
          break
        case 37:
          this.$refs.videoChild.skip(-5)
          break
        case 69:
          this.$refs.videoChild.toggleFullScreen()
          break
      }
    },
    getParameters: function () {
      var vars = {}
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value
      })
      return vars
    },
    goHome: function () {
      this.usageLog.videoCompleted = true
      if (this.videoData.returnTo !== '') {
        location = this.videoData.returnTo
      }
    },
    incrementState: function (videoState) {
      if (videoState !== 'waiting') { // Video has not loaded yet
        if (videoState === 'playing') {
          this.usageLog.durationPlayed += 1
        } else {
          this.usageLog.durationPaused += 1
        }
      }
    },
    recordSkip: function (skipDirection) {
      if (skipDirection === 'forward') {
        this.usageLog.numberSkipsForward += 1
      } else {
        this.usageLog.numberSkipsBackward += 1
      }
    },
    logUsage: function () {
      // ToDo Log failures to play.
      fetch(this.logEndPoint, {
        method: 'POST',
        credentials: 'include',
        // headers: {
        //   'Content-Type': 'application/json'
        // },
        body: JSON.stringify(this.usageLog)
      })
        .catch((error) => {
          console.log('Logging Error: ', error)
        })
    }
  },

  created: function () {
    const requestParameters = this.getParameters()
    const videoMetaDataURL = this.src + '?key=' + requestParameters.key

    this.usageLog.browser             = Bowser.parse(window.navigator.userAgent)
    this.usageLog.requestKey          = requestParameters.key // Required by end-point
    this.usageLog.requestTime         = Date.now() / 1000 | 0 // Required by end-point
    this.usageLog.numberSkipsForward  = 0 // Required by end-point
    this.usageLog.numberSkipsBackward = 0 // Required by end-point
    this.usageLog.durationPaused      = 0 // Required by end-point
    this.usageLog.durationPlayed      = 0 // Required by end-point
    this.usageLog.usedCaptions        = false
    this.usageLog.usedShortcuts       = false
    this.usageLog.videoCompleted      = false // Required by end-point

    fetch(videoMetaDataURL,
      {
        credentials: 'include'
      })
      .then((response) => {
        return response.json()
      }).then((data) => {
        if (Object.prototype.hasOwnProperty.call(data, 'accessRequest')) {
          fetch(this.authorizer, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data.accessRequest)
          })
            .then(() => {
              this.displayVideo = data.startTime === ''
            })
            .catch((error) => {
              console.error('Authorization error: ', error)
            })
        } else {
          this.displayVideo = data.startTime === ''
        }
        this.videoData = data
      })
  },

  computed: {

  },

  data: () => {
    return {
      newDate: new Date(),
      src: process.env.VUE_APP_VIDEO_ORIGIN,
      logEndPoint: process.env.VUE_APP_LOG_CONSUMER,
      authorizer: process.env.VUE_APP_VIDEO_AUTHORIZER,
      videoData: {
        title: '',
        startTime: ''
      },
      displayVideo: false,
      intervalLogger: null,
      usageLog: {}
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
  .keyboardControlTitle {
    color: #727272;
    font-weight: lighter;
  }
  .keyboardControlValue {
    color: #727272;
    margin-left:4px;
    font-size: 1.2rem;
  }
</style>
